var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.inspector
    ? _c("HKLViewLayout", { attrs: { checkIsHKL: true } }, [
        _c("div", { staticClass: "inline-block inspector-container" }, [
          _c("div", { staticClass: "row" }, [
            _c("label", { staticClass: "small-4" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("project.submission.inspector")) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "small-4" }, [
              _c("p", [_vm._v(_vm._s((_vm.inspector || {}).displayName))]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }